import {FormControl, FormField} from 'platform/components';
import {Grid, GridItem, Heading, VStack} from 'platform/foundation';

import {GetWarehouseHandlingUnitsResponse} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {getOptionsFromHandlingUnits} from '@dms/shared-aftersales';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SupplierArticlesAddNewForm} from '../types/SupplierArticlesAddNewForm';

interface SupplierArticlesAddNewQuantityAndUnitsMappingFormProps extends RequiredTestIdProps {
  control: FormControl<SupplierArticlesAddNewForm>;
  handlingUnits: GetWarehouseHandlingUnitsResponse | Nullish;
  supplierUnit: string;
  warehouseUnit: string;
}

export function SupplierArticlesAddNewQuantityAndUnitsMappingForm(
  props: SupplierArticlesAddNewQuantityAndUnitsMappingFormProps
) {
  return (
    <VStack spacing={4} data-testid={props['data-testid']}>
      <Heading size={5}>{i18n.t('entity.warehouse.labels.quantityAndUnitsMapping')}</Heading>
      <Grid columns={4} spacing={4}>
        <GridItem span={1}>
          <FormField
            isRequired
            control={props.control}
            name="quantityAndUnitsMapping.supplierQuantity"
            type="number"
            label={i18n.t('entity.warehouse.labels.supplierQuantity')}
            decimalPlaces={4}
            suffix={props.supplierUnit}
            data-testid={suffixTestId('inputs.supplierQuantity', props)}
          />
        </GridItem>
        <GridItem span={1}>
          <FormField
            isRequired
            isNotClearable
            control={props.control}
            name="quantityAndUnitsMapping.supplierUnitId"
            type="choice"
            label={i18n.t('entity.warehouse.labels.supplierUnit')}
            options={getOptionsFromHandlingUnits(props.handlingUnits)}
            data-testid={suffixTestId('inputs.supplierUnit', props)}
          />
        </GridItem>
        <GridItem span={1}>
          <FormField
            isRequired
            control={props.control}
            name="quantityAndUnitsMapping.warehouseQuantity"
            type="number"
            label={i18n.t('entity.warehouse.labels.warehouseQuantity')}
            decimalPlaces={4}
            suffix={props.warehouseUnit}
            data-testid={suffixTestId('inputs.warehouseQuantity', props)}
          />
        </GridItem>
        <GridItem span={1}>
          <FormField
            isRequired
            isDisabled
            control={props.control}
            name="quantityAndUnitsMapping.warehouseUnitId"
            type="choice"
            label={i18n.t('entity.warehouse.labels.warehouseUnit')}
            options={getOptionsFromHandlingUnits(props.handlingUnits)}
            data-testid={suffixTestId('inputs.warehouseUnit', props)}
          />
        </GridItem>
      </Grid>
    </VStack>
  );
}
